/**
 * The right-hand edge the POI sheet keeps clear of. On most pages that's the
 * map's own edge; on the planner the Actions column stands on the map's
 * right (`[data-map-dock="right"]`), and the sheet sits to its left. A dock
 * off the map (collapsed, or on another page's chrome) doesn't count. Pure.
 */
export function sheetRightEdge(mapRight: number, dockLeft: number | null | undefined): number {
  return dockLeft != null && dockLeft < mapRight ? dockLeft : mapRight;
}
